import { render } from "./DashboardLayout.html?vue&type=template&id=5e74312a&scoped=true&external"
import script from "./DashboardLayout.js?vue&type=script&lang=js&external"
export * from "./DashboardLayout.js?vue&type=script&lang=js&external"

import "./DashboardLayout.css?vue&type=style&index=0&id=5e74312a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e74312a"]])

export default __exports__